import { FormType, RouteBuilders } from "@simplyk/common";

import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { appendSearchParams, useUrlBuilder } from "@/common/hooks/useUrlBuilder";

type UseNavigateToCampaignEditorParams = {
  formId: string;
  formType: FormType;
  onExitUrl: string;
  hash?: string;
  searchParams?: Record<string, string>;
};

export const useNavigateToCampaignEditor = () => {
  const buildUrl = useUrlBuilder();
  const { isoLocale } = useLocaleContext();

  const getEditCampaignUrl = ({
    formId,
    formType,
    onExitUrl,
    hash,
    searchParams,
  }: UseNavigateToCampaignEditorParams) => {
    const editRoute =
      formType === FormType.Ticketing
        ? RouteBuilders.buildTicketingFormEditLink({ isoLocale, formId, onExitUrl })
        : RouteBuilders.buildDonationFormEditLink({ isoLocale, formId, onExitUrl });

    return buildUrl({
      route: editRoute,
      hash,
      searchParams: searchParams ? appendSearchParams(searchParams) : undefined,
    });
  };

  /** URL to open the creation flow with an existing form id (e.g. after duplicate). */
  const getCreateCampaignUrl = ({ formId, formType }: { formId: string; formType: FormType }) => {
    const createRoute =
      formType === FormType.Ticketing
        ? RouteBuilders.buildTicketingFormNewWithIdLink({ isoLocale, formId })
        : RouteBuilders.buildDonationFormNewWithIdLink({ isoLocale, formId });

    return buildUrl({ route: createRoute });
  };

  return { getEditCampaignUrl, getCreateCampaignUrl };
};
